import AppDispatcher from "../AppDispatcher";
import Constants from "../Constants";
import CurrentOrganizationIdStore from "../stores/CurrentOrganizationIdStore";
import TokenStore from "../stores/TokenStore";
import UserAPI from "../util/UserAPI";

const EulaActions = {
  signEula() {
    const organizationId = CurrentOrganizationIdStore.getOrganizationId();

    new UserAPI(TokenStore.getToken()).users
      .acceptEula(organizationId)
      .then((response) => {
        AppDispatcher.dispatch({
          actionType: Constants.EULA_SIGNATURE_ACKNOWLEDGED,
          organizationId,
        });
      });
  },
};

export default EulaActions;
